import getColor from "@insite/mobius/utilities/getColor";
import { contentSpacingStyles } from "@store/theme/common/mixins/common";
import { transitionHoverStyles } from "@store/theme/common/mixins/transition";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const titleSpacingStyles = () => {
    return contentSpacingStyles("1em", "0.5em");
};

export const linkStyles = (color = "text.link", hoverColor = "text.linkHover", underline = true) => {
    return css`
        ${focusStyles()}
        ${transitionHoverStyles("color")}
        color: ${getColor(color)};

        &:active, &:visited {
            color: ${getColor(color)};
        }

        &:hover {
            color: ${getColor(hoverColor)};
            text-decoration: ${underline ? "underline" : "none"};
        }
    `;
};

export const focusOutlineStyles = (offset?: string | true, width?: string, style?: string, color?: string) => {
    return css`
        ${({ theme }) => {
            const _offset = offset === true ? `-${theme.focus.width}` : offset;

            return `
                outline-offset: ${_offset || theme.focus.offset};
                outline-width: ${width || theme.focus.width};
                outline-style: ${style || theme.focus.style};
                outline-color: ${color || theme.focus.color};
            `;
        }}
    `;
};

export const focusStyles = (offset?: string | true, width?: string, style?: string, color?: string) => {
    return css`
        &:focus,
        &:focus-visible {
            ${focusOutlineStyles(offset, width, style, color)}
        }

        &:not(:focus-visible) {
            outline: none;
        }
    `;
};

export const editLinkStyles = () => {
    return css`
        ${({ theme }) => theme?.link?.defaultProps?.css}
        font-size: ${TYPOGRAPHY.size.smaller};
        font-weight: ${TYPOGRAPHY.weight.bold};
    `;
};

export const labelSeparationStyles = () => {
    return css`
        position: relative;
        padding-right: 11px;
        margin-right: 10px;

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 0.8em;
            background-color: ${getColor("common.borderDark")};
            transform: translateY(-50%);
        }

        &:last-child::after {
            display: none;
        }
    `;
};

export const loadingDotsAnimation = () => {
    return css`
        display: inline-block;
        text-align: left;
        font-weight: ${TYPOGRAPHY.weight.bold};
        min-width: 25px;

        &::after {
            overflow: hidden;
            display: inline-block;
            vertical-align: bottom;
            animation: ellipsis steps(4, end) 900ms infinite 1s;
            content: "\\2026";
            width: 0;
        }

        @keyframes ellipsis {
            to {
                width: 1.25em;
            }
        }
    `;
};
